
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kVx8h", function(module, exports) {

$parcel$export(module.exports, "register", () => $f3c2d4f5f568aeaa$export$6503ec6e8aabbaf, (v) => $f3c2d4f5f568aeaa$export$6503ec6e8aabbaf = v);
var $f3c2d4f5f568aeaa$export$6503ec6e8aabbaf;
var $f3c2d4f5f568aeaa$export$f7ad0328861e2f03;
"use strict";
var $f3c2d4f5f568aeaa$var$mapping = new Map();
function $f3c2d4f5f568aeaa$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f3c2d4f5f568aeaa$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f3c2d4f5f568aeaa$var$resolve(id) {
    var resolved = $f3c2d4f5f568aeaa$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f3c2d4f5f568aeaa$export$6503ec6e8aabbaf = $f3c2d4f5f568aeaa$var$register;
$f3c2d4f5f568aeaa$export$f7ad0328861e2f03 = $f3c2d4f5f568aeaa$var$resolve;

});

var $d9ad63b673e02064$exports = {};

(parcelRequire("kVx8h")).register(new URL("", import.meta.url).toString(), JSON.parse('["eOdzp","03.13fdcb45.js","jtjuA","../bird.7a8cad65.jpg","l3eUY","01.660f2584.js","99yyr","01.bff02f15.js"]'));


var $lyoVb = parcelRequire("lyoVb");
let $20ee99a66a60325b$var$img;
var $294c5551b3e886a7$exports = {};
$294c5551b3e886a7$exports = new URL("../bird.7a8cad65.jpg", import.meta.url).toString();


const $20ee99a66a60325b$var$imgUrl = new URL($294c5551b3e886a7$exports);
function $20ee99a66a60325b$export$513ccb98c53b8039() {
    $20ee99a66a60325b$var$img = loadImage($20ee99a66a60325b$var$imgUrl.href);
}
function $20ee99a66a60325b$export$de27182ff8187d6c() {
    (0, $lyoVb.setupCommon)();
    noSmooth();
    stroke(0, 0, 0, 0.25);
}
let $20ee99a66a60325b$var$xPrev = 0;
let $20ee99a66a60325b$var$yPrev = 0;
let $20ee99a66a60325b$var$cycles = -1;
function $20ee99a66a60325b$export$e529deb2bfd496dc() {
    /**
	 * Pixel Sorting
	 */ const psort = (x, idxFn, t)=>{
        // TODO: filter out segments < 5 long
        let segments = [];
        for(let y = 0; y < $20ee99a66a60325b$var$img.height; y++){
            if (segments.length % 2 == 0 && $20ee99a66a60325b$var$img.pixels[idxFn(x, y)] < t + 10) segments.push(y);
            else if (segments.length % 2 == 1 && $20ee99a66a60325b$var$img.pixels[idxFn(x, y)] > t - 10) segments.push(y);
        }
        if (segments.length % 2 == 1) segments.push($20ee99a66a60325b$var$img.height);
        for(let i = 0; i < segments.length / 2; i++){
            const y1 = segments[i];
            const y2 = segments[i + 1];
            [
                ...Array(y2 - y1).keys()
            ].map((y)=>$20ee99a66a60325b$var$img.pixels[idxFn(x, y + y1)]).sort((colorA, colorB)=>{
                if (colorA < colorB) return -1;
                else if (colorA > colorB) return 1;
                else return 0;
            }).forEach((color, idx)=>{
                const loc = idxFn(x, idx + y1);
                $20ee99a66a60325b$var$img.pixels[loc] = color + Math.floor(Math.sin(y1 * 0.01) * 5);
                $20ee99a66a60325b$var$img.pixels[loc + 1] = color + Math.floor(Math.sin(x * 0.01) * 5);
                $20ee99a66a60325b$var$img.pixels[loc + 2] = color + Math.floor(Math.sin(y2 * 0.5) * 5);
                $20ee99a66a60325b$var$img.pixels[loc + 3] = 255;
            });
        }
    };
    (0, $lyoVb.drawCommon)();
    (0, $lyoVb.setFrameN)((0, $lyoVb.frameN) * 6);
    (0, $lyoVb.setFrameN)((0, $lyoVb.frameN) - Math.floor((0, $lyoVb.frameN)));
    if ((0, $lyoVb.frameN) == 0) $20ee99a66a60325b$var$cycles++;
    if ((0, $lyoVb.frameN) < 0.5) {
        $20ee99a66a60325b$var$yPrev = 0;
        const n = (0, $lyoVb.frameN) * 2;
        const xNext = Math.floor(n * width);
        $20ee99a66a60325b$var$img.loadPixels();
        for(let x0 = $20ee99a66a60325b$var$xPrev; x0 < xNext; x0++){
            psort(x0, (x, y)=>(x + y * $20ee99a66a60325b$var$img.width) * 4, 150 + $20ee99a66a60325b$var$cycles * 5);
            line(x0, 0, x0, height);
        }
        $20ee99a66a60325b$var$img.updatePixels();
        $20ee99a66a60325b$var$xPrev = xNext;
    } else {
        $20ee99a66a60325b$var$xPrev = 0;
        const n = ((0, $lyoVb.frameN) - 0.5) * 2;
        const yNext = Math.floor(n * height);
        $20ee99a66a60325b$var$img.loadPixels();
        for(let y0 = $20ee99a66a60325b$var$yPrev; y0 < yNext; y0++)psort(y0, (y, x)=>(x + y * $20ee99a66a60325b$var$img.width) * 4, 50 + $20ee99a66a60325b$var$cycles * 5);
        $20ee99a66a60325b$var$img.updatePixels();
        $20ee99a66a60325b$var$yPrev = yNext;
    }
    image($20ee99a66a60325b$var$img, 0, 0, width, height, 0, 0, $20ee99a66a60325b$var$img.width, $20ee99a66a60325b$var$img.height, COVER);
    line($20ee99a66a60325b$var$xPrev * (width / $20ee99a66a60325b$var$img.width), 0, $20ee99a66a60325b$var$xPrev * (width / $20ee99a66a60325b$var$img.width), height);
    line(0, $20ee99a66a60325b$var$yPrev * (height / $20ee99a66a60325b$var$img.height), width, $20ee99a66a60325b$var$yPrev * (height / $20ee99a66a60325b$var$img.height));
}



var $gPx2I = parcelRequire("gPx2I");
parcelRequire("d3dEA");
const $dc9698d8071a2734$var$source = "import {\n  easeInOutSine,\n  smoothstep,\n  clamp,\n  w, h,\n  frameN,\n  setFrameN,\n  getCanvasSize,\n  setupCommon,\n  drawCommon,\n  make,\n} from '../js/common.js';\n\nlet img;\nconst imgUrl = new URL('./bird.jpg', import.meta.url);\nexport function preload() {\n	img = loadImage(imgUrl.href);\n}\n\nexport function setup() {\n	setupCommon();\n	noSmooth();\n	stroke(0, 0, 0, 0.25);\n}\n\nlet xPrev = 0;\nlet yPrev = 0;\nlet cycles = -1;\nexport function draw() {\n\n	/**\n	 * Pixel Sorting\n	 */\n	const psort = (x, idxFn, t) => {\n		// TODO: filter out segments < 5 long\n		let segments = [];\n		for (let y = 0; y < img.height; y++) {\n			if (segments.length % 2 == 0 && img.pixels[idxFn(x, y)] < t + 10)\n				segments.push(y);\n			else if (segments.length % 2 == 1 && img.pixels[idxFn(x, y)] > t - 10)\n				segments.push(y);\n		}\n		if (segments.length % 2 == 1) segments.push(img.height);\n\n		for (let i = 0; i < segments.length / 2; i++) {\n			const y1 = segments[i];\n			const y2 = segments[i + 1];\n\n			[...Array(y2 - y1).keys()]\n				.map(y => img.pixels[idxFn(x, y + y1)])\n				.sort((colorA, colorB) => {\n					if (colorA < colorB) return -1;\n					else if (colorA > colorB) return 1;\n					else return 0;\n				})\n				.forEach((color, idx) => {\n					const loc = idxFn(x, idx + y1);\n\n					img.pixels[loc] = color + Math.floor(Math.sin(y1 * 0.01) * 5);\n					img.pixels[loc + 1] = color + Math.floor(Math.sin(x * 0.01) * 5);\n					img.pixels[loc + 2] = color + Math.floor(Math.sin(y2 * 0.5) * 5);\n					img.pixels[loc + 3] = 255;\n				});\n		}\n	}\n\n	drawCommon();\n\n	setFrameN(frameN * 6);\n	setFrameN(frameN - Math.floor(frameN));\n\n	if (frameN == 0)\n		cycles++;\n\n	if (frameN < 0.5) {\n		yPrev = 0;\n\n		const n = frameN * 2;\n		const xNext = Math.floor(n * width);\n		img.loadPixels();\n		for (let x0 = xPrev; x0 < xNext; x0++) {\n			psort(x0, (x, y) => (x + y * img.width) * 4, 150 + cycles * 5);\n			line(x0, 0, x0, height);\n		}\n		img.updatePixels();\n		xPrev = xNext;\n	}\n\n	else {\n		xPrev = 0;\n\n		const n = (frameN - 0.5) * 2;\n		const yNext = Math.floor(n * height);\n		img.loadPixels();\n		for (let y0 = yPrev; y0 < yNext; y0++) {\n			psort(y0, (y, x) => (x + y * img.width) * 4, 50 + cycles * 5);\n		}\n		img.updatePixels();\n		yPrev = yNext;\n	}\n\n	image(img, 0, 0, width, height, 0, 0, img.width, img.height, COVER);\n	line(xPrev * (width / img.width), 0, xPrev * (width / img.width), height);\n	line(0, yPrev * (height / img.height), width, yPrev * (height / img.height));\n}\n";
(0, $gPx2I.make)({
    setup: $20ee99a66a60325b$export$de27182ff8187d6c,
    draw: $20ee99a66a60325b$export$e529deb2bfd496dc,
    preload: $20ee99a66a60325b$export$513ccb98c53b8039
}, $dc9698d8071a2734$var$source);


//# sourceMappingURL=03.13fdcb45.js.map
